import { hosts } from 'settings';

export const FooterDashboard = {
  template: `
    <footer class="footer-dashboard">
      <div class="container">
        <div class="row text-center">
          <div class="col-6 pr-2">
            <a class="d-block text-center p-3 btn-unstyled bg-cz-theme"
              ui-sref="nutrition.favouritesRecipes">
              <i class="icon icon-favourites fa-5x text-white d-inline-block"></i>
              <h5 class="text-white mt-1 font-size-small font-size-sm-base">
                Favourite Recipes
              </h5>
            </a>
          </div>
          <div class="col-6 px-2">
            <a class="d-block text-center p-3 btn-unstyled bg-cz-theme-secondary"
              ui-sref="profile">
              <i class="icon icon-profile fa-5x text-white d-inline-block"></i>
              <h5 class="text-white mt-1 font-size-small font-size-sm-base">
                Profile
              </h5>
            </a>
          </div>
        </div>
      </div>
    </footer>`,
};



// WEBPACK FOOTER //
// ./src/components/Footer/FooterDashboard.js